import reduce from 'lodash/reduce'
import isEqual from 'lodash/isEqual'
import { StorageType } from 'components/shared'
import { FieldErrors } from 'react-hook-form/dist/types/errors'

export const numWord = (value: number, words: string[]): string => {
  value = Math.abs(value) % 100
  const num = value % 10
  if (value > 10 && value < 20) return words[2]
  if (num > 1 && num < 5) return words[1]
  if (num == 1) return words[0]
  return words[2]
}

export const urlify = (text: string) => {
  const urlRegex = /(\b((https?|ftp|file):\/\/|(w{3}\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
  return text.replace(urlRegex, function (url, b, c) {
    const url2 = c == 'www.' ? 'http://' + url : url
    return '<a href="' + url2 + '" target="_blank">' + url + '</a>'
  })
}

export const convertFileSize = (size: number | string) => {
  const kbSize = +(Number(size) / 1024).toFixed(1)
  if (kbSize >= 1024) {
    return (kbSize / 1024).toFixed(1) + 'MB'
  }
  return kbSize + 'KB'
}

export const differenceKeysByValue = (a: Record<string, any>, b: Record<string, any>) => {
  const arr = reduce(
    a,
    function (result, value, key: any) {
      return isEqual(value, b[key]) ? result : result.concat(key)
    },
    []
  )
  return arr.join(',')
}

export const isArrayWithLength = (arr: any) => {
  return Array.isArray(arr) && arr.length
}

export const getStorageUrl = (storageType: StorageType, fileName: string | undefined, thumb?: boolean) => {
  if (thumb) {
    switch (storageType) {
      case 'company-logo':
        return `https://cdn.centra.ai/company-logo/r/50x-/${fileName}`
      case 'product-logo':
        return `https://cdn.centra.ai/product-logo/r/150x-/${fileName}`
      case 'product-media':
        return `https://cdn.centra.ai/product-media/r/50x-/${fileName}`
      case 'account-avatar':
        return `https://cdn.centra.ai/account-avatar/r/50x-/${fileName}`
      default:
        return ''
    }
  } else {
    switch (storageType) {
      case 'company-logo':
        return `https://cdn.centra.ai/company-logo/o/${fileName}`
      // return `${process.env.REACT_APP_COMPANY_LOGO_STORAGE}${fileName}`
      case 'product-logo':
        return `https://cdn.centra.ai/product-logo/o/${fileName}`
      // return `${process.env.REACT_APP_PRODUCT_LOGO_STORAGE}${fileName}`
      case 'product-media':
        return `https://cdn.centra.ai/product-media/o/${fileName}`
      case 'account-avatar':
        return `https://cdn.centra.ai/account-avatar/o/${fileName}`
      // return `${process.env.REACT_APP_ACCOUNT_AVATAR_STORAGE}${fileName}`
      default:
        return fileName
    }
  }
}

export const validURL = (str: string) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ) // fragment locator
  return !!pattern.test(str)
}

export const getValidationMessage = (name: string, errors: FieldErrors): string => {
  if (name.includes('.') || name.includes('[')) {
    return eval(`errors?.${name.replace(/[.]/gi, '?.').replace(/[[]/gi, '?.[')}?.message`)
  }
  return errors?.[name]?.message
}

export const hasClamping = (el: HTMLDivElement) => {
  const { clientHeight, scrollHeight } = el
  return clientHeight !== scrollHeight
}

export const initBeforeUnLoad = (showExitPrompt: boolean) => {
  window.onbeforeunload = (event: BeforeUnloadEvent) => {
    if (showExitPrompt) {
      const e = event || window.event
      e.preventDefault()
      if (e) {
        e.returnValue = ''
      }
      return ''
    }
  }
}
